module.exports = __webpack_public_path__ + "static/media/whatsapp-ecosentino-logo.d193fc8a.svg";